module.exports = __webpack_public_path__ + "static/logo_elecboy-89510d7264b3bf04f4440d466a35300e.svg";